<template>
  <div class="container">
    <el-breadcrumb separator-class="el-icon-arrow-right" class="p-20">
      <el-breadcrumb-item
        v-for="link in breadcrumbs"
        :key="link.path"
        :to="link.path"
      >
        {{ link.title }}
      </el-breadcrumb-item>
    </el-breadcrumb>

    <group-edit />
  </div>
</template>

<script>
import GroupEdit from './Group-edit'

export default {
  components: { GroupEdit },
  data() {
    return {
      breadcrumbs: [
        {
          path: '/',
          title: 'Главная',
        },
        {
          path: '/contragents',
          title: 'Список контрагентов',
        },
        {
          path: '/contragents/group',
          title: 'Группы контрагентов',
        },
      ],
    }
  },
}
</script>

<style>
.el-checkbox {
  display: block !important;
}

.el-transfer-panel {
  width: 300px !important;
}
</style>
